<template>
  <div class="rb-center-content">
    <div class="rb-popup-intro" v-html="data.intro"></div>
    <div class="rb-popup-image">
      <img
        :src="data.image"
        :alt="data.title"
        class="lazyload"
        loading="lazy"
      />
    </div>
    <div class="rb-popup-outro" v-html="data.outro"></div>
  </div>
</template>
<script>
/**
 * Static Popup
 *
 * @summary
 * Data is created through customizer
 *
 * @props
 * data: Object
 */
export default {
  props: {
    data: {
      type: Object,
    },
  },
};
</script>
